/* eslint-disable no-unused-vars */
import { ts } from '_core';

export type JobParams = {
  return_horizon: ts.types.returnHorizon.ReturnHorizon;
  buckets: ts.types.widgets.common.BucketValue;
  joint: boolean;
  statistics_type: 'return' | 'risk' | 'adjusted';
  ui_transformation: 'ANNUALIZED';
};

export enum INTERACTION_PARAMS {
  IS_BASKET = 'isBasket',
  HISTORIES = 'histories',
}

export type InteractionParams = {
  [INTERACTION_PARAMS.IS_BASKET]: boolean;
  [INTERACTION_PARAMS.HISTORIES]: ts.enums.HISTORY_ENUM_EXTENDED[];
};

export type Params = JobParams & InteractionParams;
export type DraftParams = Partial<Params>;
